'use strict';
var parent = require('../../actual/date');

module.exports = parent;
